import {
  GET_EMAIL_NOTIFICATIONS,
} from '../../types';
import createAsyncActions from '../../../../utilities/createAsyncActions';

export const {
  getEmailNotifications,
  getEmailNotificationsPending,
  getEmailNotificationsFulfilled,
  getEmailNotificationsRejected,
} = createAsyncActions(GET_EMAIL_NOTIFICATIONS, 'getEmailNotifications');



// WEBPACK FOOTER //
// ./src/features/organization/actions/getActions/getEmailNotificationsActions.js